import type { GetListParams } from "ra-core";

// Liste som filterverdi (`{ work_item_id: [1, 2, 3] }`) betyr «én av disse».
// fakerest i demo-modus forstår det, men ra-data-postgrest gjør den om til
// `work_item_id=eq.1,2,3`, som PostgREST avviser med 400. Kallet feiler da
// stille og lista mangler data, slik «Registrert tid» i oppgavelista gjorde.
//
// Her blir hver slik nøkkel uten operator til `nøkkel@in` med en ferdig
// kvotert PostgREST-liste: `work_item_id=in.(1,2,3)`. Nøkler som allerede har
// en operator (`tags@cs`, `kommunenr@in`) røres ikke.

const formatValue = (value: unknown) => {
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (value === null) return "null";
  // Strenger kvoteres, så komma, parenteser og punktum i verdien ikke knekker
  // lista.
  return `"${String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
};

export const toInFilter = (values: unknown[]) =>
  `(${values.map(formatValue).join(",")})`;

export const normalizeArrayFilters = <P extends Pick<GetListParams, "filter">>(
  params: P,
): P => {
  const filter = params.filter as Record<string, unknown> | undefined;
  if (!filter) return params;
  const keys = Object.keys(filter).filter(
    (key) => !key.includes("@") && Array.isArray(filter[key]),
  );
  if (keys.length === 0) return params;
  const next: Record<string, unknown> = { ...filter };
  for (const key of keys) {
    next[`${key}@in`] = toInFilter(filter[key] as unknown[]);
    delete next[key];
  }
  return { ...params, filter: next };
};
